<template>
    <NuxtLayout name="malt-full-layout">
        <main>
            <slot />
            <ClientOnboarding />
        </main>
    </NuxtLayout>
</template>

<script setup lang="ts">
    import {ClientOnboarding} from '#components';
    import {use3rdParties} from '#imports';

    use3rdParties();
</script>
